/** @jsxImportSource @emotion/react */

import { Pagination as MUIPagination } from '@mui/material'
import { FC } from 'react'
import * as classes from './styles'

interface IProps {
  pageCount: number
  onPageChange: (page: number) => void
  page: number
  className?: string
}

const Pagination: FC<IProps> = ({ pageCount, page, onPageChange, className }) => (
  <MUIPagination
    css={classes.pagination}
    className={className}
    count={pageCount}
    page={page}
    onChange={(event, page) => onPageChange(page)}
    variant="outlined"
    shape="rounded"
    size="large"
  />
)

export default Pagination
